/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

import {disable} from './disable.mjs';
import {enable} from './enable.mjs';
import {isSupported} from './isSupported.mjs';
import './_version.mjs';


/**
 * @namespace workbox.navigationPreload
 */

export {
  disable,
  enable,
  isSupported,
};
